export const BASE_URL = 'https://jalso-dev.solguruzsolutions.com';
